import { DATA_KEYS, useRemoteData } from "@/utils/useRemoteData";
import type { BetaFeature } from "./betaFeatures";

// On for this user's tenant: its flags offer the feature and a deployment
// admin turned it on.
export function useBetaFeature(feature: BetaFeature): boolean {
  const { data } = useRemoteData(
    DATA_KEYS.BETA_FEATURES,
    {},
    { staleTime: 60_000 }
  );
  return !!data?.includes(feature);
}
